"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconQuickview = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconQuickview = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 6C6.478 6 2 12.25 2 12.25s4.478 6.25 10 6.25c5.523 0 10-6.25 10-6.25S17.523 6 12 6zm0 10a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5z"
}));
exports.IconQuickview = IconQuickview;
//# sourceMappingURL=IconQuickview.js.map